declare global {
  interface Window {
    /** GET requests the landing page's inline loader made before the app started, by URL. */
    __avowEarly?: Record<string, Promise<Response>>
  }
}

/**
 * The inline loader's request for `url` (see `server/utils/render/deferAppStart.ts`), or `undefined`
 * when it made none. Each request is handed out once, so a later refresh asks the server again.
 */
function takeEarlyRequest(url: string): Promise<Response> | undefined {
  if (!import.meta.client)
    return undefined
  const early = window.__avowEarly
  const response = early?.[url]
  if (early != null)
    delete early[url]
  return response
}

/**
 * Reads the response to the inline loader's request for `url` when there is one, and calls
 * `request` otherwise or when that early request failed.
 */
export async function withEarlyResponse<T>(url: string, request: () => Promise<T>): Promise<T> {
  const response = await takeEarlyRequest(url)?.catch(() => undefined)
  // eslint-disable-next-line ts/no-unsafe-return -- the same endpoint `request` reads, so the same JSON; `$fetch<T>` trusts it no more
  return response?.ok === true ? response.json() : request()
}
